module.exports = __webpack_public_path__ + "static/img/4.a76e0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/4.jpg
// module id = Cxyn
// module chunks = 5